import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Shop from "./pages/Shop";

import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminProtected from "./component/AdminProtected";
import AdminProducts from "./pages/AdminProducts";
import AdminAddProduct from "./pages/AdminAddProduct";
import AdminEditProduct from "./pages/AdminEditProduct";
import "./App.css";
import Navbar from "./component/navbar";
import Footer from "./component/Footer";
import ProductDetails from "./pages/ProductDetails";
import Cart from "./pages/Cart";
import WhatsAppFloating from "./component/WhatsAppFloating";
import Contact from "./pages/Contact";
import AdminContactMessages from "./pages/AdminContactMessages";
import Checkout from "./pages/Checkout";
import AdminOrders from "./pages/AdminOrders";
import FAQ from "./pages/FAQ";
import ShippingPolicy from "./pages/ShippingPolicy";
import ReturnsPolicy from "./pages/ReturnsPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Sustainability from "./pages/Sustainability";

function Layout() {
  const location = useLocation();

  // Admin pages pe Navbar/Footer hide karna (optional but professional)
  const hideLayout = location.pathname.startsWith("/admin");

  return (
    <>
      {!hideLayout && <Navbar />}
<WhatsAppFloating />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin/contact-messages" element={<AdminContactMessages />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/admin/orders" element={<AdminOrders />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/faq" element={<FAQ/>} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/returns-policy" element={<ReturnsPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/sustainability" element={<Sustainability/>} />
        <Route path="/product/:id" element={<ProductDetails />} />

        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />

        <Route
          path="/admin/dashboard"
          element={
            <AdminProtected>
              <AdminDashboard />
            </AdminProtected>
          }
        />
         <Route
  path="/admin/products"
  element={
    <AdminProtected>
      <AdminProducts />
    </AdminProtected>
  }
/>

<Route
  path="/admin/add-product"
  element={
    <AdminProtected>
      <AdminAddProduct />
    </AdminProtected>
  }
/>

<Route
  path="/admin/edit-product/:id"
  element={
    <AdminProtected>
      <AdminEditProduct />
    </AdminProtected>
  }
/>
      </Routes>

      {!hideLayout && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;